
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Settings, LayoutDashboard } from "lucide-react";

export function AdminNavbar() {
  const location = useLocation();
  const { signOut } = useAuth();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <nav className="border-b">
      <div className="container mx-auto px-4">
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center space-x-4">
            <Link to="/admin/dashboard" className="font-semibold text-lg">
              Admin Panel
            </Link>
            <div className="hidden md:flex space-x-2">
              <Button
                variant={isActive("/admin/dashboard") ? "default" : "ghost"}
                size="sm"
                asChild
              >
                <Link to="/admin/dashboard">
                  <LayoutDashboard className="w-4 h-4 mr-2" />
                  Dashboard
                </Link>
              </Button>
              <Button
                variant={isActive("/admin/settings") ? "default" : "ghost"}
                size="sm"
                asChild
              >
                <Link to="/admin/settings">
                  <Settings className="w-4 h-4 mr-2" />
                  Instellingen
                </Link>
              </Button>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <Button
              variant="ghost"
              onClick={() => signOut()}
            >
              Uitloggen
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
}
